import { ListChecks, Users } from "lucide-react";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/shared/ui/tabs";
import { AdminUsersTable } from "@/widgets/AdminUsersTable";
import { AdminWhitelistTable } from "@/widgets/AdminWhitelistTable";
import { PageHeader } from "@/widgets/PageHeader";

export function AdminPage(): JSX.Element {
  return (
    <>
      <PageHeader
        title={<>Админ <span className="text-gradient">панель</span></>}
        subtitle="Управление пользователями и белым списком email-ов"
      />
      <Tabs defaultValue="users">
        <TabsList className="flex w-full overflow-x-auto sm:w-auto">
          <TabsTrigger value="users">
            <Users className="h-3.5 w-3.5" /> Пользователи
          </TabsTrigger>
          <TabsTrigger value="whitelist">
            <ListChecks className="h-3.5 w-3.5" /> Белый список
          </TabsTrigger>
        </TabsList>

        <TabsContent value="users">
          <AdminUsersTable />
        </TabsContent>
        <TabsContent value="whitelist">
          <AdminWhitelistTable />
        </TabsContent>
      </Tabs>
    </>
  );
}
